import { safeLocalStorage } from "@helpers/storage"

const FACEBOOK_CLICK_ID_KEY = "fbc"

export function addFacebookParamsToLocalStorage(locationSearch: string) {
  const urlSearchParams = new URLSearchParams(locationSearch)

  addFbcToLocalStorage(urlSearchParams)
}

function addFbcToLocalStorage(urlSearchParams: URLSearchParams) {
  const fbclid = urlSearchParams.get("fbclid")

  if (fbclid) {
    const creationTime = Date.now()
    const subdomainIndex = import.meta.env.MODE === "development" ? 0 : 1

    // NOTE: https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/#2--format-clickid
    const fbc = `fb.${subdomainIndex}.${creationTime}.${fbclid}`

    safeLocalStorage.setItem(FACEBOOK_CLICK_ID_KEY, fbc)
  }
}

// NOTE: Through safeLocalStorage: reading `localStorage` throws when the
// browser blocks storage, and RootOutlet reads this on every page view
// (PRODUCTION-S6 / -S7).
export function getFbcFromLocalStorage(): string | null {
  return safeLocalStorage.getItem(FACEBOOK_CLICK_ID_KEY)
}
